module.exports = __webpack_public_path__ + "static/img/react-logo.a308ce61.svg";